var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2048 12.2117C15.2048 12.2117 14.1149 14.0417 11.5049 16.1517C9.38485 17.8617 7.05485 19.2617 5.59485 19.0817C3.01485 18.7617 2.90485 15.5617 3.03485 13.7317C3.29485 10.3017 4.54485 8.56171 6.00485 7.32171C7.94485 5.68171 9.77484 5.38171 11.7048 5.98171C11.8848 6.04171 12.0548 6.11171 12.2148 6.21171L15.6949 8.23171",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1943 5.87147C14.1743 5.31147 15.3543 4.67147 15.3543 4.67147C17.1343 3.64147 20.4543 3.69147 20.8443 5.56147C21.0943 6.76147 20.0943 8.77147 19.7543 9.52147C19.7543 9.54147 19.7443 9.55147 19.7343 9.57147C18.7243 11.7315 16.0843 12.6615 13.7843 11.8515L11.1543 10.9215",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiver);
export default __webpack_public_path__ + "static/media/Liver.cce601062e7af85f9aa32aeccf03b810.svg";
export { ForwardRef as ReactComponent };